const className = 'Device'

export default class Device {
  constructor (Parse) {
    this.Parse = Parse
  }

  getById (id) {
    var Class = this.Parse.Object.extend(className)
    var query = new this.Parse.Query(Class)
    query.equalTo('data.id', id)
    query.include('data').include('user').include('site').include('template')
    query.include('site.rates', 'site.change', 'site.messages')
    return query
  }

  set (id, user, site, template, options = {}) {
    var Class = this.Parse.Object.extend(className)
    var object = new Class()
    object.set('user', user, {error: this.onError})
    object.set('data',  {id: id}, {error: this.onError})
    object.set('site', site, {error: this.onError})
    object.set('template', template, {error: this.onError})
    return object.save(null, options)
  }

  onError (object, error) {
    console.log('Error', error)
  }
}


//////////////////
// WEBPACK FOOTER
// ./parse-model/Device.mjs
// module id = ClAw
// module chunks = 0